<template>
  <div>
    <personal-info :sidebar="true" />
  </div>
</template>

<script>

import Unauthorised from "VuePartials/App/Unauthorised";
import PersonalInfo from "VuePartials/App/Preferences/Tabs/PersonalInfo";
import LegacyInfo from "VuePartials/App/Preferences/Tabs/LegacyInfo";

// Misc
Vue.component("unauthorised", Unauthorised);
Vue.component("personal-info", PersonalInfo);
Vue.component("legacy-info", LegacyInfo);

export default {
  name: "EditUser",
  components: {
    PersonalInfo,
  },

  data: () => ({
    user: window.user, // The user that we have clicked on
  }),

};
</script>
